enum FacilityStatus {
    OK = 0,
    WARNING = 1,
    ERROR = 2,
}

enum FacilityStatusStrings {
    ALL = 'ALL',
    OK = '0',
    WARNING = '1',
    ERROR = '2',
}

export { FacilityStatus, FacilityStatusStrings }
